(function () {
    function  intersectionObserverGlobal(ele, cb, rootMargin) {
        if (typeof Array.isArray === 'undefined') {
            Array.isArray = function(obj) {
                return Object.prototype.toString.call(obj) === '[object Array]';
            }
        }
        if ('IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype && 'isIntersecting' in window.IntersectionObserverEntry.prototype) {
            var options = {
                "rootMargin": (rootMargin)? rootMargin:"0px" 
            }
            var lazyEleObserver = new IntersectionObserver(function(entries, observer){
                entries.forEach(function(entry){
                    if (entry.isIntersecting) {
                        var lazyEle = entry.target;
                        cb(lazyEle);
                        lazyEleObserver.unobserve(lazyEle);
                    }
                });
            },options);
            if(Array.isArray(ele)) {
                ele.forEach(function(item) {
                    lazyEleObserver.observe(item);
                })
            } else {
                lazyEleObserver.observe(ele);
            }
        } else {
            if(Array.isArray(ele)) {
                for(var i = 0; i< ele.length;i++) {
                    cb(ele[i])
                }
            } else {
                cb(ele);
            }
        }
    }
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = intersectionObserverGlobal;
    } else if (!window.intersectionObserverGlobal) {
        window.intersectionObserverGlobal = intersectionObserverGlobal;
    }

})();


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/initObs.js
// module id = 458
// module chunks = 0